/**
 * The four counts above the Suppliers list, read from the report summary so
 * the tiles, the list and the Reports page all count the same suppliers: one
 * per supplier account, by its latest application.
 *
 * In flight is everything not yet finished either way — drafts, every review
 * stage, returned for more information, and approved but not yet completed —
 * so the three always add up to the total.
 */
const outcome = (summary, key) =>
  (summary?.outcomes || []).find((o) => o.key === key)?.count || 0;

export const supplierTiles = (summary) => {
  const total = summary?.total || 0;
  const completed = outcome(summary, 'completed');
  const rejected = outcome(summary, 'rejected');
  return { total, inFlight: total - completed - rejected, completed, rejected };
};

/**
 * The status bars on the Dashboard and Reports: the pipeline in workflow order,
 * then Completed as the last bar, so finished suppliers sit at the end of the
 * line they came down rather than in a separate list beside it. Rejected stays
 * off the bars, as it is not a step anyone moves through.
 */
export const statusBars = (summary) => {
  const completed = (summary?.outcomes || []).find((o) => o.key === 'completed');
  return [...(summary?.pipeline || []), ...(completed ? [completed] : [])];
};

/**
 * Every status on the Reports chart: the pipeline in workflow order, then the
 * supplier sent back for more information, then the two outcomes, then any
 * status no stage recognises. All of them are bars, so the chart accounts for
 * every supplier in the total and nothing is left in a list beneath it. The
 * unrecognised bar appears only when something is in it.
 */
export const allStatusBars = (summary) => [
  ...(summary?.pipeline || []),
  ...(summary?.exception ? [summary.exception] : []),
  ...(summary?.outcomes || []),
  ...(summary?.unrecognised?.count > 0 ? [summary.unrecognised] : []),
];
